import React from 'react';
import Lottie from 'react-lottie';
import lottieJson from 'lottie/loading_mochipay_white';
import styles from 'components/loading-dialog/index.module.scss';
import classname from 'classnames/bind';

const cx = classname.bind(styles);

const LoadingDialog = ({ isShow = false }) => {
  const options = {
    loop: true,
    autoplay: true,
    animationData: lottieJson,
  };

  const dialogClasses = cx({
    'loading-dialog': true,
    show: isShow,
  });

  return (
    <div className={dialogClasses}>
      <Lottie width={70} height={70} options={options} />
    </div>
  );
};

export default LoadingDialog;
